import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useContext } from 'react';
import { BusinessToolsContext } from '../contexts/BusinessToolsContext';
import { CommonContext } from '../contexts/CommonContext';
import { DownloadContext } from '../contexts/DownloadsContext';
import { OrderContext } from '../contexts/OrderContext';
import { OrderDetailsContext } from '../contexts/OrderDetailsContext';
import { Phase0BarcodeContext } from '../contexts/Phase0BarcodeContext';
import { PTCDocumentsContext } from '../contexts/components/PTCDocumentsContext';
import { PurchaseHistoryContext } from '../contexts/PurchaseHistoryContext';
import { ReturnLabelContext } from '../contexts/ReturnLabelContext';
import { SearchResultsContext } from '../contexts/SearchResultsContext';
import { FulfillmentGroupContext } from '../contexts/FulfillmentGroupContext';
import { EditPickupPersonContext } from '../contexts/EditPickupPersonContext';
import { EditPickupLocationContext } from '../contexts/EditPickupLocationContext';
import { EditDeliveryInstructionsContext } from '../contexts/EditDeliveryInstructionsContext';
import { IAppContext, IExperienceContext } from '../models/common';
import { EditDeliveryAddressContext } from '../contexts/EditDeliveryAddressContext';
import { ViewChargedDetailsContext } from '../contexts/ViewChargedDetailsContext';

export const useAppContext = () => {
  const context = useContext<IAppContext>(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within a AppProvider');
  }
  return context;
};

export const useBusinessToolsContext = () => {
  const context = useContext(BusinessToolsContext);
  if (context === undefined) {
    throw new Error(
      'useBusinessToolsContext must be used within a BusinessToolsProvider',
    );
  }
  return context;
};

export const useCommonContext = () => {
  const context = useContext(CommonContext);
  if (context === undefined) {
    throw new Error('useCommonContext must be used within a CommonProvider');
  }
  return context;
};

// Contexts hook for Downloads Page
export const useDownloadsContext = () => {
  const context = useContext(DownloadContext);
  if (context === undefined) {
    throw new Error(
      'useDownloadsContext must be used within a DownloadProvider',
    );
  }
  return context;
};

// Contexts hook for Experience context
export const useExperienceContext = () => {
  const context = useContext<IExperienceContext>(ExperienceContext);
  if (context === undefined) {
    throw new Error(
      'useExperienceContext must be used within a ExperienceProvider',
    );
  }
  return context;
};

export const useOrderDetailsContext = () => {
  const context = useContext(OrderDetailsContext);
  if (context === undefined) {
    throw new Error(
      'useOrderDetailsContext must be used within a OrderDetailsProvider',
    );
  }
  return context;
};

export const useOrderContext = () => {
  const context = useContext(OrderContext);
  if (context === undefined) {
    throw new Error('useOrderContext must be used within a OrderProvider');
  }
  return context;
};

export const useEditDeliveryAddressContext = () => {
  const context = useContext(EditDeliveryAddressContext);
  if (context === undefined) {
    throw new Error(
      'useEditDeliveryAddressContext must be used within a EditDeliveryAddressProvider',
    );
  }
  return context;
};

export const useEditDeliveryInstructionsContext = () => {
  const context = useContext(EditDeliveryInstructionsContext);
  if (context === undefined) {
    throw new Error(
      'useEditDeliveryInstructionsContext must be used within a EditDeliveryInstructionsProvider',
    );
  }
  return context;
};

export const usePurchaseHistoryContext = () => {
  const context = useContext(PurchaseHistoryContext);
  if (context === undefined) {
    throw new Error(
      'usePurchaseHistoryContext must be used within a PurchaseHistoryProvider',
    );
  }
  return context;
};

export const useSearchResultsContext = () => {
  const context = useContext(SearchResultsContext);
  if (context === undefined) {
    throw new Error(
      'useSearchResultsContext must be used within a SearchResultsProvider',
    );
  }
  return context;
};

export const useFulfillmentGroupContext = () => {
  const context = useContext(FulfillmentGroupContext);
  if (context === undefined) {
    throw new Error(
      'useFulfillmentGroupContext must be used within a FulfillmentGroupProvider',
    );
  }
  return context;
};

export const useEditPickupPersonContext = () => {
  const context = useContext(EditPickupPersonContext);
  if (context === undefined) {
    throw new Error(
      'useEditPickupPersonContext must be used within a EditPickupPersonProvider',
    );
  }
  return context;
};

export const useEditPickupLocationContext = () => {
  const context = useContext(EditPickupLocationContext);
  if (context === undefined) {
    throw new Error(
      'useEditPickupLocationContext must be used within a EditPickupLocationProvider',
    );
  }
  return context;
};

// ------------------------------------------- Below are hooks for components specifically ---------------------------------------

export const useReturnLabelContext = () => {
  const context = useContext(ReturnLabelContext);
  if (context === undefined) {
    throw new Error(
      'useReturnLabelContext must be used within a ReturnLabelProvider',
    );
  }
  return context;
};

export const usePhase0BarcodeContext = () => {
  const context = useContext(Phase0BarcodeContext);
  if (context === undefined) {
    throw new Error(
      'usePhase0BarcodeContext must be used within a Phase0BarcodeProvider',
    );
  }
  return context;
};

export const usePTCDocumentsContext = () => {
  const context = useContext(PTCDocumentsContext);
  if (context === undefined) {
    throw new Error(
      'usePTCDocumentsContext must be used within a PTCDocumentsProvider',
    );
  }
  return context;
};

export const useViewChargedDetailsContext = () => {
  const context = useContext(ViewChargedDetailsContext);
  if (context === undefined) {
    throw new Error(
      'useViewChargedDetailsContext must be used within a ViewChargedDetailsProvider',
    );
  }
  return context;
};
